// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__7mb-V","rotate":"Loader_rotate__1+Csk"};